import React, { useState } from 'react'

interface NurserySearchProps {
  onSearch: (filters: NurseryFilters) => void
  initialFilters?: NurseryFilters
}

export interface NurseryFilters {
  searchQuery?: string
  specializations?: string[]
  tradeTypes?: string[]
  page?: number
  limit?: number
}

const NurserySearch: React.FC<NurserySearchProps> = ({ onSearch, initialFilters = {} }) => {
  const [filters, setFilters] = useState<NurseryFilters>(initialFilters)
  const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState<boolean>(false)

  const handleSearchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => ({ ...prev, searchQuery: e.target.value }))
  }

  const handleTradeTypeChange = (tradeType: string) => {
    setFilters(prev => {
      const currentTradeTypes = prev.tradeTypes || []
      const newTradeTypes = currentTradeTypes.includes(tradeType)
        ? currentTradeTypes.filter(t => t !== tradeType)
        : [...currentTradeTypes, tradeType]

      return {
        ...prev,
        tradeTypes: newTradeTypes
      }
    })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSearch(filters)
  }

  const handleClearFilters = () => {
    setFilters({})
    onSearch({})
  }

  // Funkcja mapująca typ handlu na etykiety (do wyświetlania)
  const getTradeTypeLabel = (tradeType: string): string => {
    switch (tradeType) {
      case 'retail':
        return 'Handel detaliczny'
      case 'wholesale':
        return 'Handel hurtowy'
      case 'both':
        return 'Hurtowy i detaliczny'
      default:
        return tradeType
    }
  }

  return (
    <div className='nursery-search mb-40'>
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-md-8'>
            <div className='form-group'>
              <input
                type='text'
                className='form-control'
                placeholder='Szukaj szkółek...'
                value={filters.searchQuery || ''}
                onChange={handleSearchQueryChange}
              />
            </div>
          </div>
          <div className='col-md-4'>
            <button
              type='submit'
              className={`
                  tw-w-full tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                  tw-text-white
                  tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                `}
            >
              <i className='fas fa-search mr-2' /> Szukaj
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default NurserySearch
